import { useEffect, useState } from 'react'
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

export const ProductImage = ({ imgInfo }: { imgInfo: string }) => {
  const [imgLink, setImgLink] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    setImgLink(imgInfo)
  }, [])
  return (
    <Box sx={{ height: theme.spacing(5), width: theme.spacing(5) }}>
      {imgLink.length > 0 ? (
        <img
          src={imgLink}
          style={{ height: theme.spacing(5), width: theme.spacing(5) }}
          alt={t('productPhoto')}
          onError={() => setImgLink('')}
        />
      ) : (
        <InsertPhotoIcon
          sx={{
            height: theme.spacing(5),
            width: theme.spacing(5),
            fill: theme.palette.action.disabled,
            '&:hover': { fill: theme.palette.action.disabled },
          }}
        />
      )}
    </Box>
  )
}
